module.exports = __webpack_public_path__ + "static/media/m12.85d9ffce.jpg";